(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "classnames", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("classnames"), require("react-dom")) : factory(root["react"], root["prop-types"], root["classnames"], root["react-dom"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__39155__, __WEBPACK_EXTERNAL_MODULE__81949__, __WEBPACK_EXTERNAL_MODULE__60992__, __WEBPACK_EXTERNAL_MODULE__69514__) => {
return 